import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return ["existingLeads", "existingLeadsText"]
  }

  connect() {
    this.updateButtonText()
    this.element.addEventListener('change', this.handleSelection.bind(this))
  }

  disconnect() {
    this.element.removeEventListener('change', this.handleSelection.bind(this))
  }

  handleSelection(event) {
    if (event.target.matches('input[type="radio"]')) {
      this.updateButtonText()
    }
  }

  updateButtonText() {
    const selectedRadio = this.element.querySelector('input[type="radio"]:checked')
    const dropdownButton = this.element.querySelector('.h-select')

    if (selectedRadio && dropdownButton) {
      const dropdownItem = selectedRadio.closest('.dropdown-item')

      if (dropdownItem) {
        const titleElement = dropdownItem.querySelector('.custom-option__title')
        const subtitleElement = dropdownItem.querySelector('.custom-option__subtitle')

        if (titleElement && subtitleElement) {
          const optionTitle = titleElement.textContent.trim()
          const optionSubtitle = subtitleElement.textContent.trim()

          dropdownButton.textContent = optionTitle

          if (this.hasExistingLeadsTextTarget) {
            this.existingLeadsTextTarget.textContent = optionSubtitle
          }
        }
      }
    }
  }
}
